import classnames from "classnames";

import style from "./style.module.scss";
import ControlBase from "../control-base";
import type { ControlTextareaProps } from "../../types";

function ControlTextarea({ label, touched, error, ...props }: ControlTextareaProps) {
  return (
    <ControlBase label={label} touched={touched} error={error}>
      {(id) => (
        <textarea
          className={classnames(style.textarea, {
            [style.hasError]: error && touched,
          })}
          id={id}
          {...props}
        />
      )}
    </ControlBase>
  );
}

export default ControlTextarea;
